var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3Pin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 445.5,
    y1: 265,
    x2: 627.5,
    y2: 265,
    gradientTransform: "translate(0 2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05dab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0acd77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 701.2,
    y1: 800.7,
    x2: 865.4,
    y2: 800.7,
    gradientTransform: "translate(0 2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05dab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0acd77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 217.6,
    y1: 791.9,
    x2: 399.6,
    y2: 791.9,
    gradientTransform: "translate(0 2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05dab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0acd77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 462.6,
    y1: 347.9,
    x2: 610.4,
    y2: 347.9,
    gradientTransform: "translate(0 2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05dab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0acd77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 666.2,
    y1: 737.2,
    x2: 775.2,
    y2: 737.2,
    gradientTransform: "translate(0 2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05dab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0acd77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 308.6,
    y1: 737.2,
    x2: 417.6,
    y2: 737.2,
    gradientTransform: "translate(0 2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05dab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0acd77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 92.12,
    y1: 538.45,
    x2: 987.88,
    y2: 538.45,
    gradientTransform: "translate(0 2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05dab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0acd77"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 536.5,
    cy: 267,
    r: 91,
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 783.3,
    cy: 802.7,
    r: 82.1,
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.6,
    cy: 793.9,
    r: 91,
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 536.5,
    cy: 349.9,
    r: 73.9,
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.7,
    cy: 739.2,
    r: 54.5,
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.1,
    cy: 739.2,
    r: 54.5,
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.4,18.8H880.6c48.2,0,87.3,39.1,87.3,87.3V974.8c0,48.2-39.1,87.3-87.3,87.3H199.4c-48.2,0-87.3-39.1-87.3-87.3V106.1c0-48.2,39.1-87.3,87.3-87.3Z",
    style: {
      fill: "none",
      stroke: "url(#linear-gradient-7)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "39.96px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Pin);
export default __webpack_public_path__ + "static/media/3pin.977b6c58179e9e603ffed5672f972bd0.svg";
export { ForwardRef as ReactComponent };